const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function attributionHandoff(search: string) {
  const query = new URLSearchParams(search);
  const candidate = (query.get('sorteia_click_id') || query.get('click_id') || query.get('clickId') || '').trim();
  const clickId = UUID_PATTERN.test(candidate) ? candidate.toLowerCase() : '';
  // The resolved internal handoff already points to the stored provider click.
  const handoffKeys = ['sorteia_click_id','click_id','clickId','delivery','dl'];
  handoffKeys.forEach((key) => query.delete(key));
  const cleanSearch = query.toString();
  return { clickId, cleanSearch: cleanSearch ? `?${cleanSearch}` : '' };
}

/** A home-screen launch has no query; retain the landing click once on that origin. */
export function isPwaAttributionStartup(search: string, saved: string | null, click: string | null) {
  const query = new URLSearchParams(search);
  return !!saved && UUID_PATTERN.test(saved) && saved === click
    && !['delivery','dl','fbclid','ttclid','gclid','msclkid','click_id','utm_source','utm_medium','utm_campaign','utm_content','utm_term'].some(key => query.has(key));
}

/** Keep the installed start URL attributed when brand metadata refreshes. */
export function attributedManifestUrl(version: string, search: string, savedClick: string | null) {
  const query = new URLSearchParams(search);
  const result = new URLSearchParams({v: version});
  const delivery = (query.get('delivery') || query.get('dl') || '').toUpperCase();
  const candidate = query.get('sorteia_click_id') || query.get('click_id') || '';
  const click = UUID_PATTERN.test(candidate) ? candidate : savedClick || '';
  if (/^[A-Z][A-Z0-9_-]{1,31}$/.test(delivery)) result.set('delivery', delivery);
  else if (UUID_PATTERN.test(click)) result.set('click_id', click.toLowerCase());
  return '/api/brand/manifest.webmanifest?' + result.toString();
}
